module.exports = __webpack_public_path__ + "img/bike_enabled.7667bf8e.svg";